module.exports = __webpack_public_path__ + "img/216.493771ad.png";